import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewAnswerFlag from '@app/src/components/Drawer/Views/DrawerViewAnswerFlag'
import { useAmplitude } from '@app/src/context/AmplitudeContext'
import type { AnswerFlagRuleResult } from '@app/src/types/answerFlags'
import { AnswerFlagArea } from '@app/src/types/resourceExplorer'
import { compareByRiskStatus, getAnswerFlagDescription } from '@app/src/utils/answerFlagUtils'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { RiskAreaItem } from './RiskAreaCard'
import RiskAreaCard from './RiskAreaCard'
import { AmplitudeTrackingEvents } from '@app/src/wf-constants'

interface AnswerFlagCardProps {
  answerFlagRuleResults: AnswerFlagRuleResult[]
}

function AnswerFlagCard({ answerFlagRuleResults }: AnswerFlagCardProps): React.ReactElement {
  const { formatMessage } = useIntl()
  const { openDrawer } = useDrawer()
  const { trackEvent } = useAmplitude()

  const items: RiskAreaItem[] = useMemo(() => {
    return [...answerFlagRuleResults].sort(compareByRiskStatus(item => item.riskStatus)).map(ruleResult => {
      const description = getAnswerFlagDescription(ruleResult)
      return {
        id: ruleResult.id,
        title: description,
        riskStatus: ruleResult.riskStatus,
        providerId: ruleResult.providerId,
        onClick: () => {
          trackEvent({
            name: AmplitudeTrackingEvents.Analyze.SupplierRisk.ClickedTopicRisk,
            eventProps: {
              providerId: ruleResult.providerId,
              sustainabilityArea: AnswerFlagArea,
              topic: description,
            },
          })
          openDrawer(<DrawerViewAnswerFlag title={description} answerFlagRuleResult={ruleResult} />)
        },
      }
    })
  }, [answerFlagRuleResults, openDrawer])

  return (
    <RiskAreaCard area={AnswerFlagArea} title={formatMessage({ id: 'sustainabilityArea.answerFlag' })} items={items} />
  )
}

export default AnswerFlagCard
